import { api } from '../api';
import { type Lang, getLang, setLang as setI18nLang, t } from '../i18n';
import { toastError } from './Toasts';

const OPTIONS: { v: Lang; l: string }[] = [
  { v: 'he', l: 'עב' },
  { v: 'en', l: 'EN' },
  { v: 'ur', l: 'اردو' },
  { v: 'tl', l: 'TL' },
];

export function LangSwitch() {
  const current = getLang();

  async function pick(next: Lang) {
    if (next === current) return;
    try {
      await api('/v1/me', {
        method: 'PATCH',
        body: JSON.stringify({ preferred_lang: next }),
      });
    } catch (e) {
      // The server kept the old preferred_lang, so the local language stays
      // put too — switching here and reloading anyway would silently diverge
      // the two, and a non-ApiError rethrown from this async handler is just
      // an unhandled rejection.
      toastError(e);
      return;
    }
    setI18nLang(next);
    window.location.reload();
  }

  // Native <select> is the right primitive on mobile — iOS / Android
  // render it as a full-screen wheel which is faster and more accessible
  // than a hand-built popover. We just enlarge the hit-target so it
  // hits the 44×44 iOS HIG minimum.
  return (
    <select
      aria-label={t('Language')}
      value={current}
      onChange={(e) => void pick(e.target.value as Lang)}
      className="touch rounded-md border border-border bg-card px-3 text-sm font-medium text-foreground/80 shadow-sm hover:border-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-ring/25"
    >
      {OPTIONS.map((o) => (
        <option key={o.v} value={o.v}>
          {o.l}
        </option>
      ))}
    </select>
  );
}
